module.exports = __webpack_public_path__ + "img/1F1E6-1F1E9.6ff54b1f.svg";